import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function ConfirmNotify() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [slug, setSlug] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    // React.StrictMode double-invocation guard — confirm is idempotent on
    // the server but a defensive ref keeps the UI from flickering.
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    http.get(`/access-restricted/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => { setState("ok"); setSlug(r.data.brand_slug); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="bp-container py-24 text-center max-w-xl" data-testid="confirm-notify-page">
      {state === "loading" && <div className="animate-pulse h-6 w-40 bg-neutral-200 mx-auto" />}
      {state === "ok" && (
        <>
          <h1 className="font-serif text-4xl mb-4" data-testid="confirm-notify-title">{t.notify_confirm_title}</h1>
          <p style={{ color: "var(--bp-text-secondary)" }}>{t.notify_confirm_body}</p>
          {slug && <Link to={`/brands/${slug}`} className="bp-link mt-6 inline-block">← {slug}</Link>}
        </>
      )}
      {state === "error" && (
        <>
          <h1 className="font-serif text-4xl mb-4" data-testid="confirm-notify-error">{t.notify_confirm_invalid}</h1>
          <Link to="/" className="bp-link">Home →</Link>
        </>
      )}
    </div>
  );
}
